import { RouteRecordRaw } from 'vue-router'

import { ADD_ON_ROUTE_NAMES } from '@/modules/addon/constants/AddOnRouteNames'
import { csAreaRoute } from '@/modules/continuousService/routes/CSAreaRoute'
import { PROMO_CODE_ROUTE_NAMES } from '@/modules/promoCode/constants/PromoCodeRouteNames'
import { SETTING_ROUTE_NAMES } from '@/modules/setting/constants/SettingRouteNames'
import { USER_ROUTE_NAMES } from '@/modules/user/constants/UserRouteNames'

import { UserGroup } from '@generated/types'

export const settingRoutes: RouteRecordRaw[] = [
  {
    name: SETTING_ROUTE_NAMES.ROOT,
    path: '/venue/settings',
    redirect() {
      return { name: SETTING_ROUTE_NAMES.FEES }
    },
    component: () => import('@/modules/setting/layouts/SettingLayout.vue'),
    meta: { requiresAuth: UserGroup.OWNERS, pageTitle: 'Settings' },
    children: [
      {
        path: 'fees',
        name: SETTING_ROUTE_NAMES.FEES,
        component: () => import('@/modules/setting/pages/SettingExposeFee.vue'),
      },
      {
        path: 'taxes',
        name: SETTING_ROUTE_NAMES.TAXES,
        component: () => import('@/modules/setting/pages/SettingTaxes.vue'),
      },
      {
        path: 'misc',
        name: SETTING_ROUTE_NAMES.MISC,
        component: () => import('@/modules/setting/pages/SettingMisc.vue'),
      },
      {
        path: 'checkout',
        name: SETTING_ROUTE_NAMES.CHECKOUT,
        component: () => import('@/modules/setting/pages/SettingCheckout.vue'),
      },
      {
        path: 'dashboard',
        name: SETTING_ROUTE_NAMES.SETUP,
        component: () => import('@/modules/setting/pages/SettingDashboard.vue'),
      },
      {
        path: 'integrations',
        children: [
          {
            path: 'mailchimp',
            name: SETTING_ROUTE_NAMES.MAILCHIMP,
            component: () => import('@/modules/setting/pages/SettingMailchimp.vue'),
          },
        ],
      },
      {
        path: 'add-on',
        name: ADD_ON_ROUTE_NAMES.ADD_ON_LIST,
        component: () => import('@/modules/addon/layouts/AddOnLayout.vue'),
        props: route => {
          const addOnId = route.params.addOnId
          if (!addOnId) return { addOnId: undefined }
          return { addOnId: isNaN(Number(addOnId)) ? addOnId : Number(addOnId) }
        },
        children: [
          {
            path: ':addOnId/edit',
            name: ADD_ON_ROUTE_NAMES.ADD_ON_EDIT,
            component: () => import('@/modules/addon/pages/AddOnEdit.vue'),
            props: route => {
              const addOnId = route.params.addOnId
              return { addOnId: isNaN(Number(addOnId)) ? addOnId : Number(addOnId) }
            },
          },
        ],
      },
      {
        path: 'promo-codes',
        name: PROMO_CODE_ROUTE_NAMES.PROMO_CODE_LIST,
        component: () => import('@/modules/promoCode/layouts/PromoCodeLayout.vue'),
        props: route => {
          const promoCodeId = route.params.promoCodeId
          if (!promoCodeId) return { promoCodeId: undefined }
          return { promoCodeId: isNaN(Number(promoCodeId)) ? promoCodeId : Number(promoCodeId) }
        },
        children: [
          {
            path: ':promoCodeId/edit',
            name: PROMO_CODE_ROUTE_NAMES.PROMO_CODE_EDIT,
            component: () => import('@/modules/promoCode/pages/PromoCodeEdit.vue'),
            props: route => {
              const promoCodeId = route.params.promoCodeId
              return { promoCodeId: isNaN(Number(promoCodeId)) ? promoCodeId : Number(promoCodeId) }
            },
          },
        ],
      },
      {
        path: 'user',
        name: USER_ROUTE_NAMES.USER_LIST,
        component: () => import('@/modules/user/layouts/UserLayout.vue'),
        props: route => {
          const userId = route.params.userId
          if (!userId) return { userId: undefined }
          return { userId: isNaN(Number(userId)) ? userId : Number(userId) }
        },
        children: [
          {
            path: ':userId/edit',
            name: USER_ROUTE_NAMES.USER_EDIT,
            component: () => import('@/modules/user/pages/UserEdit.vue'),
            props: route => {
              const userId = route.params.userId
              return { userId: isNaN(Number(userId)) ? userId : Number(userId) }
            },
          },
        ],
      },
      csAreaRoute,
      {
        path: 'payments',
        name: SETTING_ROUTE_NAMES.PAYMENTS,
        component: () => import('@/modules/setting/pages/SettingPayments.vue'),
      },
      {
        path: 'payments2',
        name: SETTING_ROUTE_NAMES.PAYMENTS2,
        component: () => import('@/modules/setting/pages/SettingPayments2.vue'),
      },
      {
        path: 'email-templates',
        name: SETTING_ROUTE_NAMES.EMAIL_TEMPLATES,
        component: () => import('@/modules/setting/pages/SettingEmailTemplates.vue'),
      },
    ],
  },
]
